import { ListCommentaryBoxes } from '@features/commentaryBox/components/ListCommentaryBoxes'
import { createFileRoute, useParams } from '@tanstack/react-router'

const ListCommentaryRoute = () => {
  const { orgId } = useParams({ from: '/_auth/o/$orgId/commentaryBox/' })
  return <ListCommentaryBoxes orgId={orgId} />
}
export const Route = createFileRoute('/_auth/o/$orgId/commentaryBox/')({
  component: ListCommentaryRoute,
})
